import React, { FC } from 'react';
import ScrollToTop from '../../../components/layout/ScrollToTop';
import { Box, Container, Stack, Typography } from '@mui/material';

const Datenschutz: FC<{}> = () => {
	return (
		<>
			<ScrollToTop />
			<Container>
				<Stack spacing={4}>
					<Typography variant="h5">Datenschutzbeauftragte der Stadt Dortmund</Typography>
					<Typography variant="h2">Datenschutz und Informationsfreiheit</Typography>

					<Box>
						<Typography variant="body1">
							In der Stadtverwaltung Dortmund werden auf vielfältige Weise personenbezogene Daten verarbeitet, zum Beispiel
							beim Ordnungsamt, Sozialamt oder bei den Bürgerdiensten. Im Zeitalter der Digitalisierung und von Big Data
							hat das Grundrecht jedes Einzelnen auf informationelle Selbstbestimmung eine besondere Bedeutung erlangt.
						</Typography>
					</Box>

					<Typography variant="body2">
						Die EU-Datenschutzgrundverordnung (EU-DSGVO) in Verbindung mit dem nordrhein-westfälischen
						Datenschutz-Anpassungs- und Umsetzungsgesetz für das Land Nordrhein-Westfalen (NRWDSAnpUG-EU) verpflichtet die
						Stadt Dortmund als öffentliche Stelle, das informationelle Selbstbestimmungsrecht und die Betroffenenrechte des
						Einzelnen zu beachten. Die Datenschutzbeauftragte hat darauf zu achten, dass die vorgenannten Bestimmungen sowie
						weitere datenschutzrechtliche Vorschriften innerhalb der Stadtverwaltung Dortmund beachtet werden. Sie ist für
						die Bürger*innen Ansprechpartner*in bei Fragen zum Datenschutz im Zusammenhang mit der Verarbeitung ihrer
						personenbezogenen Daten bei der Stadtverwaltung Dortmund. Auch Mitarbeiter*innen der Stadtverwaltung Dortmund
						können sich an die Datenschutzbeauftragte*n wenden.
					</Typography>
				</Stack>
			</Container>
		</>
	);
};
export default Datenschutz;
